import { render, staticRenderFns } from "./ViewMethodPublicationBiases.vue?vue&type=template&id=55b32f14&scoped=true"
import script from "./ViewMethodPublicationBiases.vue?vue&type=script&lang=js"
export * from "./ViewMethodPublicationBiases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b32f14",
  null
  
)

export default component.exports